import { GridColDef, GridColumnResizeParams } from '@mui/x-data-grid';
import { useCallback, useMemo, useState } from 'react';

export const useColumnWidths = (columns: GridColDef[]) => {
  const [widths, setWidths] = useState<Record<string, number>>(() =>
    columns.reduce<Record<string, number>>((acc, column) => {
      if (column.width != null) {
        acc[column.field] = column.width;
      }
      return acc;
    }, {})
  );

  const [resizedColumns, setResizedColumns] = useState<Set<string>>(
    () => new Set()
  );

  const handleColumnWidthChange = useCallback(
    (params: GridColumnResizeParams) => {
      const field = params.colDef.field;
      setWidths((previousWidths) => ({
        ...previousWidths,
        [field]: params.width
      }));
      setResizedColumns((prev) => {
        const next = new Set(prev);
        next.add(field);
        return next;
      });
    },
    []
  );

  const columnsWithWidths = useMemo(
    () =>
      columns.map((column) => {
        const isResized = resizedColumns.has(column.field);
        const storedWidth = widths[column.field];
        return {
          ...column,
          ...(isResized && storedWidth !== undefined
            ? { width: storedWidth, flex: undefined }
            : storedWidth !== undefined
              ? { width: storedWidth }
              : {})
        };
      }),
    [columns, widths, resizedColumns]
  );

  return { columnsWithWidths, handleColumnWidthChange };
};
